import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './Container.module.scss';

export const Container = ({children, fullSize, className}) => (
  <div className={cn(styles.wrap, className, {[styles.fullSize]: fullSize})}>
    {children}
  </div>
);

Container.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fullSize: PropTypes.bool,
};

Container.defaultProps = {
  className: null,
  fullSize: false,
};
